import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AlertService} from '../../services/alert/alert.service';
import {ReportsService} from '../../services/reports/reports.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import _ from 'lodash';
import {FRTSummaryTspListFilter} from './frt-summary-tsp-list-filter';
import moment from 'moment';
import { DomLayoutType, GridApi } from "ag-grid-community";

@Component({
    selector: 'app-frt-tsp-summary-list',
    templateUrl: './frt-summary-tsp-list.component.html',
    styleUrls: ['./frt-summary-tsp-list.component.css'],
    standalone: false
})


export class FrtSummaryTspListComponent implements OnInit {
  public errorMessage:string = '';
  filterGroup: UntypedFormGroup;
  order:string = 'frt';
  reverse:boolean = false;
  // may need to improve searching results
  frt_filter: FRTSummaryTspListFilter = {
    beginDate: 0,
    endDate: Date.now()
  };
  private gridApi: GridApi;
  paginationPageSize:number;
  domLayout: DomLayoutType;
  frtTspListDetails = [
    {}
  ];
  frtTspListColumnDefs = [
    {
      headerName: 'SCAC Code',
      field: 'scac',
      filter: 'agTextColumnFilter',
      cellRenderer: params => {
        return '<a tabindex="0">' + params.data.scac + '</a>';
      },
      onCellClicked: event =>  this.onScacClicked(event.data.carrierID, event.data.agencyMasterID),
      sortable: true,
      resizable: true
    },
    {
      headerName: 'TSP Name',
      field: 'tspName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Agency Name',
      field: 'agencyName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true
    },
    {
      headerName: 'Bureau Name',
      field: 'bureauName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Auth TSP POC',
      field: 'tspContact',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'TSP POC Email', 
      field: 'tspPocEmail', 
      filter: 'agTextColumnFilter', 
      sortable: true, 
      resizable: true, 
      type: 'series',
    },
    {headerName: 'Total # Shipments', field: 'totalShipments', filter: 'agTextColumnFilter', sortable: true, resizable: true, chartDataType: 'category'},
    {headerName: 'Total Spend Amt', field: 'totalSpendAmt', filter: 'agTextColumnFilter', sortable: true, width: 150, resizable: true, chartDataType: 'series'}
  ];
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];

  constructor(private reportsService: ReportsService,
              private alertService: AlertService,
              private loadingService: LoadingService,
              private fb: UntypedFormBuilder,
              private router: Router
  ) {
    this.paginationPageSize = 25;
  }

  ngOnInit() {
    this.generateFormGroupController();
    this.onSearch();
  }

  generateFormGroupController() {
    this.filterGroup = this.fb.group({
      fromDate: new UntypedFormControl(''),
      toDate: new UntypedFormControl('')
    });
  }

  seatchByFilter() {
    this.onSearch();
    const params = {
      force: true
    };
    this.gridApi.refreshCells(params);
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  onSearch() {
    this.frtTspListDetails = [];
    this.errorMessage = '';
    this.loadingService.show();
    const beginDate = new Date(this.filterGroup.get('fromDate').value).getTime();
    const endDate = new Date(this.filterGroup.get('toDate').value).getTime();
    this.reportsService.getFrtTspDetails(this.order, this.reverse, beginDate ? beginDate : this.frt_filter.beginDate, endDate ? endDate : this.frt_filter.endDate)
      .subscribe(data => {
          this.frtTspListDetails = data;
        }, (error) => {
          this.errorMessage = error;
          this.alertService.error('No records found for the search criteria ');
          this.loadingService.hide();
        }, () => {
          // console.log('Successfully retrieved frt list details: ', this.frtTspListDetails);
          this.loadingService.hide();
        }
      );
  }

  dateConverter(date: any) {
    return moment(date).format('MM/DD/YYYY');
  }

  setupPayload() {
    this.frt_filter.beginDate = (!_.isDate(this.filterGroup.get('fromDate').value)) ?
      0 : Date.parse(this.filterGroup.get('fromDate').value);
    this.frt_filter.endDate = (!_.isDate(this.filterGroup.get('toDate').value)) ?
      Date.now() : Date.parse(this.filterGroup.get('toDate').value);
  }

  resetFilter() {
    this.frt_filter.beginDate = null;
    this.frt_filter.endDate = null;
  }

  filterFromDateChange(formDate: any) {
    if (formDate === '' || formDate === null) {
    } else {
      if (!_.isDate(this.filterGroup.get('toDate').value)) {
        if (Date.parse(formDate) < Date.now()) {
          console.log('must be less than current date');
        }
      } else {
        if (formDate > this.filterGroup.get('toDate').value) {
          console.log('must be smaller');
        }
      }
    }
    this.filterGroup.get('fromDate').updateValueAndValidity();
  }

  filterToDateChange(toDate: any) {
    if (toDate === '' || toDate === null) {
    } else {
      if (!_.isDate(this.filterGroup.get('toDate').value)) {

      } else {
        if (!_.isDate(this.filterGroup.get('fromdate').value)) {
        } else {
          if (toDate > this.filterGroup.get('fromdate').value) {
            console.log('must be smaller');
          }
        }
      }
    }
    this.filterGroup.get('toDate').updateValueAndValidity();
  }

  turnOnvalidationFromDate() {
    this.filterGroup.get('fromdate').setValidators([Validators.required]);
  }

  turnOnvalidationToDate() {
    this.filterGroup.get('toDate').setValidators([Validators.required]);
  }

  onScacClicked(scacSelected: number, agencyMasterID : number) {
    console.log(scacSelected);
    const beginDate = new Date(this.filterGroup.get('fromDate').value).getTime();
    const endDate = new Date(this.filterGroup.get('toDate').value).getTime();
    this.reportsService.getFrtTspDetails(this.order, this.reverse, beginDate ? beginDate : this.frt_filter.beginDate, endDate ? endDate : this.frt_filter.endDate)
    this.router.navigate(['/', 'frtshipmentcomprehensivereport'],
      {queryParams: {carrierID: scacSelected,
        agencyMasterID: agencyMasterID,
        beginDate: beginDate ? beginDate : this.frt_filter.beginDate,
        endDate: endDate ? endDate : this.frt_filter.endDate
      }});
  }
}
